import { useMeQuery, useReferralStatsQuery } from '@streamster/shared/api/api.portal';
import { Me } from '@streamster/shared/api/types';
import { BusinessUserSwitcher } from '#/components/BusinessUserSwitcher/BusinessUserSwitcher';
import Heading from '#/components/Heading/Heading';
import Loader from '@streamster/shared/components/Loader/Loader';
import PageWrapper from '#/components/PageWrapper/PageWrapper';
import { useSelectedBusinessUserStore } from '@streamster/shared/screens/home/selectedBusinessUser.store';
import { ReferAFriendBox } from '#/screens/referAFriend/ReferAFriend';

export const ReferAFriendScreen = () => {
  const { data: profile } = useMeQuery();
  const { selectedUserId } = useSelectedBusinessUserStore();

  if (!profile) {
    return <Loader />;
  }

  return (
    <PageWrapper>
      {selectedUserId && !profile.business ? (
        <BusinessUserSwitcher />
      ) : (
        <Heading variant="page">Refer a friend</Heading>
      )}
      <ProfileContainer profile={profile} />
    </PageWrapper>
  );
};

const ProfileContainer = ({ profile }: { profile: Me }) => {
  const stats = useReferralStatsQuery();

  if (stats.isPending || !stats.data) {
    return <Loader />;
  }

  return <ReferAFriendBox user={profile} stats={stats.data} />;
};
